import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import visionariesBG from '../images/visionariesbg.png';

const founders = [
  {
    image: require('../images/Founders/SomeshJ.webp'),
    name: 'Somesh Jaiswal',
    title: 'Co-Founder & CEO',
  },
  {
    image: require('../images/Founders/ChetanV.webp'),
    name: 'Chetan Vidhate',
    title: 'Co-Founder & COO',
  },
];

const visionaries = [
  {
    image: require('../images/Visionaries/Edurado.webp'),
    name: 'Edurado Latouche',
    title: 'Senior Advisor',
  },
  {
    image: require('../images/Visionaries/Swapnil2024.webp'),
    name: 'Swapnil M',
    title: 'Chief Product Officer',
  },
  {
    image: require('../images/Visionaries/Riddhi.webp'),
    name: 'Riddhi Madeka',
    title: 'Head of User Experience',
  },
  {
    image: require('../images/Visionaries/SagarA.webp'),
    name: 'Sagar A',
    title: 'Head of Software',
  },
  {
    image: require('../images/Visionaries/KrishnaM.webp'),
    name: 'Krishna M',
    title: 'Head of AI',
  },
  {
    image: require('../images/Visionaries/DhruvJ.webp'),
    name: 'Dhruv Jain',
    title: 'Full Stack Developer Intern',
  },
  {
    image: require('../images/Visionaries/MananG.webp'),
    name: 'Manan Gupta',
    title: 'Growth Intern',
  },
  {
    image: require('../images/Visionaries/BhargaviG.webp'),
    name: 'Bhargavi Gawande',
    title: 'UI/UX Designer Intern',
  },
  {
    image: require('../images/Visionaries/ShivamT.webp'),
    name: 'Shivam Tiwari',
    title: 'UI/UX Designer Intern',
  },
  {
    image: require('../images/Visionaries/AnushkaK.webp'),
    name: 'Anushka Kumari',
    title: 'Chief of Staff to the Founders',
  },
];

const AboutUsPage = () => {
  const navigate = useNavigate();
  return (
    <div>
      <section className="bg-white py-12 px-4 md:px-20 font-roboto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          {/* Text Section */}
          <div>
            <p className="w-full font-semibold text-black leading-tight text-4xl sm:text-[50px]">
              <span
                className="bg-clip-text text-transparent"
                style={{
                  backgroundImage:
                    'linear-gradient(330deg, #6C3BB7 0%, #7636D9 20%, #8E5DDA 70%)',
                }}
              >
                MakerSharks:
              </span>{' '}
              <br />
              Redefining Manufacturing <br />
              <span
                className="bg-clip-text text-transparent"
                style={{
                  backgroundImage:
                    'linear-gradient(330deg, #6C3BB7 0%, #8E5DDA 10%, #7636D9 80%)',
                }}
              >
                Efficiency
              </span>
            </p>
            <p className="mt-6 text-[14px]  text-[#536770]">
              At <span className="text-[#7636D9]">MakerSharks</span>, we make
              scaling manufacturing faster, smarter, and more efficient. Our
              platform connects businesses with pre-vetted manufacturers
              worldwide, automating key processes like sourcing, quotation
              management, and purchase orders—all in one place. By streamlining
              these critical workflows, we help companies get their products to
              market faster, save thousands on production costs, and eliminate
              the headaches of managing complex supply chains. The impact is
              clear: we empower businesses to focus on innovation rather than
              operational bottlenecks. With{' '}
              <span className="text-[#7636D9]">MakerSharks</span>, what used to
              take months can now be done in days, transforming how companies
              bring hardware products to market.
            </p>
            <p className="mt-4 text-[14px] text-[#536770]">
              Born out of our own frustrations as hardware founders,{' '}
              <span className="text-[#7636D9]">MakerSharks </span>
              was created to solve the challenges of finding reliable
              manufacturers, managing procurement, and ensuring on-time
              production. We’ve built a platform that removes these barriers,
              making manufacturing more accessible for small and medium-sized
              businesses.
            </p>
            <p className="mt-4 text-[14px] text-[#536770]">
              Driven by a world-class team with deep expertise in manufacturing,
              software, and entrepreneurship, we’re committed to constant
              iteration and customer obsession. Our goal? To transform the
              global manufacturing supply chain, one streamlined process at a
              time.
            </p>
          </div>
          {/* Image Section */}
          <div className="relative flex justify-end">
            <img
              src={require('../images/aboutusimage.webp')}
              alt="Two people discussing a project"
              className=""
            />
          </div>
        </div>

        {/* Vision and Mission Section */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8 border border-[1px] rounded-3xl ">
          <div className=" p-8 rounded-lg ">
            <h2 className="text-[32px]">Our Vision</h2>
            <p className="mt-4 text-[#536770] text-[14px]">
              We envision a future where manufacturing is accessible, efficient,
              and globally connected. By combining advanced technology with a
              human touch, we aim to make manufacturing smarter, faster, and
              more sustainable for businesses everywhere. As we continuously
              innovate, we remain committed to empowering companies to scale
              effortlessly, reduce time-to-market, and transform the global
              supply chain for a more resilient and sustainable future.
            </p>
          </div>
          <div className="p-8 rounded-lg">
            <h2 className="text-[32px]">Our Mission</h2>
            <p className="mt-4 text-[#536770] text-[14px]">
              At MakerSharks, our mission is to revolutionize manufacturing
              scalability by connecting businesses with the right manufacturers
              through innovative, intelligent sourcing solutions. We strive to
              be the fastest-iterating company in the world, continuously
              improving to ensure that our customers can bring their products to
              market faster, more efficiently, and with fewer headaches.
            </p>
          </div>
        </div>

        {/* Meet Our Visionaries*/}
        {/* <div className="text-center overflow-hidden bg-white px-4 py-8 lg:mt-10 lg:py-14 lg:px-12 lg:pl-16">
          <h2 className="text-4xl sm:text-[56px] leading-tight font-bold text-black">
            Meet Our{' '}
            <span
              className="bg-clip-text text-transparent"
              style={{
                backgroundImage:
                  'linear-gradient(310deg, #6C3BB7 0%, #9652FF 20%, #9652FF 30%)',
              }}
            >
              Visionaries
            </span>
          </h2>
          <div className="grid grid-cols-2 gap-4 lg:grid lg:grid-cols-4 lg:gap-x-28 lg:gap-y-20 lg:mt-16">
            <div className="hidden lg:block"></div>
            {founders.map((data, index) => (
              <div
                key={index}
                className={`relative lg:h-[320px] lg:w-[250px] flex flex-col items-center mx-auto`}
              >
                <img
                  src={data.image}
                  alt={data.name}
                  className={` ${data.name === 'Somesh Jaiswal' ? 'h-full w-full lg:absolute lg:bottom-0 lg:-right-[6px] lg:h-[350px] lg:w-full' : 'h-full w-full'} z-10 object-cover rounded-t-lg`}
                />
                <div className="absolute bottom-2 left-0 z-20 w-4/5 bg-white text-center py-2 rounded-r-lg">
                  <p className="font-bold text-[14px]">{data.name}</p>
                  <p className="text-[11px] text-[#536770]">{data.title}</p>
                </div>
                <img
                  src={visionariesBG}
                  alt={data.name}
                  className="w-full absolute bottom-0 left-0 w-4/5 object-cover rounded-t-lg"
                />
              </div>
            ))}
            <div></div>
            <div></div>
          </div>
          <div className="grid grid-cols-2 gap-4 lg:grid lg:grid-cols-5 lg:gap-x-32 lg:gap-y-20">
            {visionaries.map((data, index) => (
              <div
                key={index}
                className="relative lg:h-[260px] lg:w-[200px] flex flex-col items-center justify-center mx-auto"
              >
                <img
                  src={data.image}
                  alt={data.name}
                  className="h-full w-full z-10 object-cover rounded-t-lg"
                />
                <div className="absolute bottom-2 z-20 left-0 w-4/5 bg-white text-center py-2 rounded-r-lg">
                  <p className="font-bold text-[14px]">{data.name}</p>
                  <p className="text-[11px] text-[#536770]">{data.title}</p>
                </div>
                <img
                  src={visionariesBG}
                  alt={data.name}
                  className="h-auto w-full absolute bottom-0 left-0 w-4/5 object-cover rounded-lg"
                />
              </div>
            ))}
          </div>
        </div> */}

        {/* Join the MakerSharks Waitlist Section */}
        <div
          className="relative px-4 lg:px-20 py-6 rounded-lg mt-16 flex flex-col justify-between"
          style={{
            background: 'linear-gradient(45deg, #E2DCEB 0%, #8D53E7 100%)',
          }}
        >
          <div className="relative z-10">
            <h2 className="text-3xl lg:text-[50px] leading-tight">
              Experience MakerSharks in <br /> Action
            </h2>
            <p className="mt-4 text-lg text-black text-opacity-70">
              Be the First to Experience the Future of Manufacturing!
            </p>
            <button
              className="mt-4 px-8 py-3 text-white text-xl font-semibold rounded-xl shadow-lg transition-transform transform hover:scale-105"
              style={{
                background:
                  'linear-gradient(126deg, #6C3BB7 0%, #A689D2 28%, #7636D9 60%)',
                backgroundBlendMode: 'overlay',
              }}
              onClick={() =>
                navigate('/', { state: { scrollToWaitlist: true } })
              }
            >
              Book a Demo
            </button>
          </div>

          {/* Image Section */}
          <div className="hidden lg:block absolute right-0 bottom-0">
            <img
              src={require('../images/aboutUsWaitlistImage.webp')}
              alt="Team of Visionaries"
              className="h-64 md:h-80 object-cover"
            />
          </div>
        </div>
      </section>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default AboutUsPage;
